const autoNgTemplateLoaderTemplate1 = require('./stack-redeploy-git-form.html');

import angular from 'angular';
import controller from './stack-redeploy-git-form.controller.js';

export const stackRedeployGitForm = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    model: '<',
    stack: '<',
    endpoint: '<',
  },
};

angular.module('portainer.app').component('stackRedeployGitForm', stackRedeployGitForm);
